import { render } from "./PaymentView.vue?vue&type=template&id=cc59c372&scoped=true"
import script from "./PaymentView.vue?vue&type=script&lang=js"
export * from "./PaymentView.vue?vue&type=script&lang=js"

import "./PaymentView.vue?vue&type=style&index=0&id=cc59c372&scoped=true&lang=css"

import exportComponent from "/Users/kokleng/Documents/old_macbook/document/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc59c372"]])

export default __exports__